<div class="modal-body">
  @switch (data.status) {
    @case (AddReferralStatuses.INVITATION_ALREADY_SENT) {
      <div class="flex flex-col justify-center items-center">
        <div class="flex flex-col justify-center items-center">
          <i nz-icon>
            <svg xmlns="http://www.w3.org/2000/svg" width="49" height="48" viewBox="0 0 49 48" fill="none">
              <mask
                id="mask0_3746_72793"
                style="mask-type: alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="49"
                height="48"
              >
                <rect x="0.5" width="48" height="48" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_3746_72793)">
                <path
                  d="M25.5 34C26.0667 34 26.5417 33.8083 26.925 33.425C27.3083 33.0417 27.5 32.5667 27.5 32C27.5 31.4333 27.3083 30.9583 26.925 30.575C26.5417 30.1917 26.0667 30 25.5 30C24.9333 30 24.4583 30.1917 24.075 30.575C23.6917 30.9583 23.5 31.4333 23.5 32C23.5 32.5667 23.6917 33.0417 24.075 33.425C24.4583 33.8083 24.9333 34 25.5 34ZM23.5 26H27.5V14H23.5V26ZM25.5 44C22.7333 44 20.1333 43.475 17.7 42.425C15.2667 41.375 13.15 39.95 11.35 38.15C9.55 36.35 8.125 34.2333 7.075 31.8C6.025 29.3667 5.5 26.7667 5.5 24C5.5 21.2333 6.025 18.6333 7.075 16.2C8.125 13.7667 9.55 11.65 11.35 9.85C13.15 8.05 15.2667 6.625 17.7 5.575C20.1333 4.525 22.7333 4 25.5 4C28.2667 4 30.8667 4.525 33.3 5.575C35.7333 6.625 37.85 8.05 39.65 9.85C41.45 11.65 42.875 13.7667 43.925 16.2C44.975 18.6333 45.5 21.2333 45.5 24C45.5 26.7667 44.975 29.3667 43.925 31.8C42.875 34.2333 41.45 36.35 39.65 38.15C37.85 39.95 35.7333 41.375 33.3 42.425C30.8667 43.475 28.2667 44 25.5 44Z"
                  fill="#F28334"
                />
              </g>
            </svg>
          </i>
          <h4 class="paragraph-large bold m-0 py-2">
            {{ 'referral.verifyInvite.alreadyInvited' | translate }}
          </h4>
        </div>
        <p class="paragraph-medium regular text-center">
          {{ 'referral.verifyInvite.youAlreadyInvitedThisPerson' | translate }}
        </p>
      </div>
    }
    @case (AddReferralStatuses.INVITED) {
      <div class="flex flex-col justify-center items-center">
        <div class="flex flex-col justify-center items-center">
          <i nz-icon>
            <svg xmlns="http://www.w3.org/2000/svg" width="49" height="48" viewBox="0 0 49 48" fill="none">
              <mask
                id="mask0_3746_19348"
                style="mask-type: alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="49"
                height="48"
              >
                <rect x="0.5" width="48" height="48" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_3746_19348)">
                <path
                  d="M22.7 33.2L36.8 19.1L34 16.3L22.7 27.6L17 21.9L14.2 24.7L22.7 33.2ZM25.5 44C22.7333 44 20.1333 43.475 17.7 42.425C15.2667 41.375 13.15 39.95 11.35 38.15C9.55 36.35 8.125 34.2333 7.075 31.8C6.025 29.3667 5.5 26.7667 5.5 24C5.5 21.2333 6.025 18.6333 7.075 16.2C8.125 13.7667 9.55 11.65 11.35 9.85C13.15 8.05 15.2667 6.625 17.7 5.575C20.1333 4.525 22.7333 4 25.5 4C28.2667 4 30.8667 4.525 33.3 5.575C35.7333 6.625 37.85 8.05 39.65 9.85C41.45 11.65 42.875 13.7667 43.925 16.2C44.975 18.6333 45.5 21.2333 45.5 24C45.5 26.7667 44.975 29.3667 43.925 31.8C42.875 34.2333 41.45 36.35 39.65 38.15C37.85 39.95 35.7333 41.375 33.3 42.425C30.8667 43.475 28.2667 44 25.5 44Z"
                  fill="#0D9443"
                />
              </g>
            </svg>
          </i>
          <h4 class="paragraph-large bold m-0 py-2">
            {{
              isGanasocios
                ? ('referral.verifyInvite.referralSubmitted' | translate)
                : ('referral.verifyInvite.successHeader' | translate)
            }}
          </h4>
        </div>
        @if (isUserTypeSpecial()) {
          <p class="paragraph-medium regular text-center">
            {{ 'referral.verifyInvite.successDescriptionSpecial' | translate }}
          </p>
        } @else {
          <p class="paragraph-medium regular text-center">
            {{ 'referral.verifyInvite.successDescription' | translate }}
          </p>
        }
      </div>
    }
    @case (AddReferralStatuses.WHATSAPP_READY) {
      <div class="flex flex-col justify-center items-center">
        <div class="flex flex-col justify-center items-center">
          <i nz-icon>
            <svg xmlns="http://www.w3.org/2000/svg" width="49" height="48" viewBox="0 0 49 48" fill="none">
              <mask
                id="mask0_whatsapp_ready"
                style="mask-type: alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="49"
                height="48"
              >
                <rect x="0.5" width="48" height="48" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_whatsapp_ready)">
                <path
                  d="M22.7 33.2L36.8 19.1L34 16.3L22.7 27.6L17 21.9L14.2 24.7L22.7 33.2ZM25.5 44C22.7333 44 20.1333 43.475 17.7 42.425C15.2667 41.375 13.15 39.95 11.35 38.15C9.55 36.35 8.125 34.2333 7.075 31.8C6.025 29.3667 5.5 26.7667 5.5 24C5.5 21.2333 6.025 18.6333 7.075 16.2C8.125 13.7667 9.55 11.65 11.35 9.85C13.15 8.05 15.2667 6.625 17.7 5.575C20.1333 4.525 22.7333 4 25.5 4C28.2667 4 30.8667 4.525 33.3 5.575C35.7333 6.625 37.85 8.05 39.65 9.85C41.45 11.65 42.875 13.7667 43.925 16.2C44.975 18.6333 45.5 21.2333 45.5 24C45.5 26.7667 44.975 29.8667 43.925 31.8C42.875 34.2333 40.95 36.35 39.65 38.15C37.85 39.95 35.7333 41.375 33.3 42.425C30.8667 43.475 28.2667 44 25.5 44Z"
                  fill="#0D9443"
                />
              </g>
            </svg>
          </i>
          <h4 class="paragraph-large bold m-0 py-2">
            {{ 'referral.verifyInvite.whatsappReadyHeader' | translate }}
          </h4>
        </div>
        <p class="paragraph-medium regular text-center">
          {{ 'referral.verifyInvite.whatsappReadyDescription' | translate }}
        </p>
      </div>
    }
    @case (AddReferralStatuses.PENDING_APPROVAL) {
      <div class="flex flex-col justify-center items-center">
        <div class="flex flex-col justify-center items-center">
          <i nz-icon>
            <svg xmlns="http://www.w3.org/2000/svg" width="49" height="48" viewBox="0 0 49 48" fill="none">
              <mask
                id="mask0_pending_approval"
                style="mask-type: alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="49"
                height="48"
              >
                <rect x="0.5" width="48" height="48" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_pending_approval)">
                <path
                  d="M25.5 34C26.0667 34 26.5417 33.8083 26.925 33.425C27.3083 33.0417 27.5 32.5667 27.5 32C27.5 31.4333 27.3083 30.9583 26.925 30.575C26.5417 30.1917 26.0667 30 25.5 30C24.9333 30 24.4583 30.1917 24.075 30.575C23.6917 30.9583 23.5 31.4333 23.5 32C23.5 32.5667 23.6917 33.0417 24.075 33.425C24.4583 33.8083 24.9333 34 25.5 34ZM23.5 26H27.5V14H23.5V26ZM25.5 44C22.7333 44 20.1333 43.475 17.7 42.425C15.2667 41.375 13.15 39.95 11.35 38.15C9.55 36.35 8.125 34.2333 7.075 31.8C6.025 29.3667 5.5 26.7667 5.5 24C5.5 21.2333 6.025 18.6333 7.075 16.2C8.125 13.7667 9.55 11.65 11.35 9.85C13.15 8.05 15.2667 6.625 17.7 5.575C20.1333 4.525 22.7333 4 25.5 4C28.2667 4 30.8667 4.525 33.3 5.575C35.7333 6.625 37.85 8.05 39.65 9.85C41.45 11.65 42.875 13.7667 43.925 16.2C44.975 18.6333 45.5 21.2333 45.5 24C45.5 26.7667 44.975 29.8667 43.925 31.8C42.875 34.2333 40.95 36.35 39.65 38.15C37.85 39.95 35.7333 41.375 33.3 42.425C30.8667 43.475 28.2667 44 25.5 44Z"
                  fill="#F28334"
                />
              </g>
            </svg>
          </i>
          <h4 class="paragraph-large bold m-0 py-2">
            {{ 'referral.verifyInvite.pendingApprovalHeader' | translate }}
          </h4>
        </div>
        <p class="paragraph-medium regular text-center">
          {{ 'referral.verifyInvite.pendingApprovalDescription' | translate }}
        </p>
      </div>
    }
    @case (AddReferralStatuses.INVALIDPHONE) {
      <div class="flex flex-col justify-center items-center">
        <div class="flex flex-col justify-center items-center">
          <i nz-icon>
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="49" viewBox="0 0 48 49" fill="none">
              <mask
                id="mask0_3746_53094"
                style="mask-type: alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="48"
                height="49"
              >
                <rect y="0.5" width="48" height="48" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_3746_53094)">
                <path
                  d="M17.8 34.5L25 27.3L32.2 34.5L35 31.7L27.8 24.5L35 17.3L32.2 14.5L25 21.7L17.8 14.5L15 17.3L22.2 24.5L15 31.7L17.8 34.5ZM25 44.5C22.2333 44.5 19.6333 43.975 17.2 42.925C14.7667 41.875 12.65 40.45 10.85 38.65C9.05 36.85 7.625 34.7333 6.575 32.3C5.525 29.8667 5 27.2667 5 24.5C5 21.7333 5.525 19.1333 6.575 16.7C7.625 14.2667 9.05 12.15 10.85 10.35C12.65 8.55 14.7667 7.125 17.2 6.075C19.6333 5.025 22.2333 4.5 25 4.5C27.7667 4.5 30.3667 5.025 32.8 6.075C35.2333 7.125 37.35 8.55 39.15 10.35C40.95 12.15 42.375 14.2667 43.425 16.7C44.475 19.1333 45 21.7333 45 24.5C45 27.2667 44.475 29.8667 43.425 32.3C42.375 34.7333 40.95 36.85 39.15 38.65C37.35 40.45 35.2333 41.875 32.8 42.925C30.3667 43.975 27.7667 44.5 25 44.5Z"
                  fill="#DF2525"
                />
              </g>
            </svg>
          </i>
          <h4 class="paragraph-large bold m-0 py-2">
            {{ 'referral.verifyInvite.failureInvalidNumber' | translate }}
          </h4>
        </div>
        <p class="paragraph-medium regular text-center">
          {{ 'referral.verifyInvite.failureInvalidNumberDescription' | translate }}
        </p>
      </div>
    }
    @case (AddReferralStatuses.ALREADYREGISTERED) {
      <div class="flex flex-col justify-center items-center">
        <div class="flex flex-col justify-center items-center">
          <i nz-icon>
            <svg xmlns="http://www.w3.org/2000/svg" width="49" height="48" viewBox="0 0 49 48" fill="none">
              <mask
                id="mask0_3746_72793"
                style="mask-type: alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="49"
                height="48"
              >
                <rect x="0.5" width="48" height="48" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_3746_72793)">
                <path
                  d="M25.5 34C26.0667 34 26.5417 33.8083 26.925 33.425C27.3083 33.0417 27.5 32.5667 27.5 32C27.5 31.4333 27.3083 30.9583 26.925 30.575C26.5417 30.1917 26.0667 30 25.5 30C24.9333 30 24.4583 30.1917 24.075 30.575C23.6917 30.9583 23.5 31.4333 23.5 32C23.5 32.5667 23.6917 33.0417 24.075 33.425C24.4583 33.8083 24.9333 34 25.5 34ZM23.5 26H27.5V14H23.5V26ZM25.5 44C22.7333 44 20.1333 43.475 17.7 42.425C15.2667 41.375 13.15 39.95 11.35 38.15C9.55 36.35 8.125 34.2333 7.075 31.8C6.025 29.3667 5.5 26.7667 5.5 24C5.5 21.2333 6.025 18.6333 7.075 16.2C8.125 13.7667 9.55 11.65 11.35 9.85C13.15 8.05 15.2667 6.625 17.7 5.575C20.1333 4.525 22.7333 4 25.5 4C28.2667 4 30.8667 4.525 33.3 5.575C35.7333 6.625 37.85 8.05 39.65 9.85C41.45 11.65 42.875 13.7667 43.925 16.2C44.975 18.6333 45.5 21.2333 45.5 24C45.5 26.7667 44.975 29.3667 43.925 31.8C42.875 34.2333 41.45 36.35 39.65 38.15C37.85 39.95 35.7333 41.375 33.3 42.425C30.8667 43.475 28.2667 44 25.5 44Z"
                  fill="#F28334"
                />
              </g>
            </svg>
          </i>
          <h4 class="paragraph-large bold m-0 py-2">
            {{ 'referral.verifyInvite.failureAlreadyRegistered' | translate }}
          </h4>
        </div>

        @if (isUserTypeSpecial()) {
          <p class="paragraph-medium regular text-center">
            {{ 'dashboard.thisPersonIsAlreadyUniGanaMember' | translate }}
          </p>
        } @else {
          <p class="paragraph-medium regular text-center">
            {{ 'referral.verifyInvite.failureAlreadyRegisteredDescription' | translate }}
          </p>
        }
      </div>
    }
  }
  <div *nzModalFooter class="referral-verification-actions flex justify-between items-stretch gap-2 sm:gap-4">
    <!-- INVITED -->
    @if (isTrackableStatus) {
      <korviu-button color="ghost" (click)="onTrackReferralClick()" class="w-full">
        @if (isGanasocios) {
          {{ 'referral.trackGanasocio' | translate }}
        } @else if (isUserTypeSpecial()) {
          {{ 'referral.trackMember' | translate }}
        } @else {
          {{ 'referral.trackReferral' | translate }}
        }
      </korviu-button>
    }
    @if (isTrackableStatus) {
      <korviu-button color="tertiary" (click)="onAddReferralClick()" class="w-full">
        @if (isGanasocios) {
          {{ 'referral.addGanasocio' | translate }}
        } @else if (isUserTypeSpecial()) {
          {{ 'referral.addMember' | translate }}
        } @else {
          {{ 'referral.addReferral' | translate }}
        }
      </korviu-button>
    }
    <!-- INVALID PHONE -->
    @if (isStatusInvalidPhone) {
      <korviu-button color="tertiary" (click)="onTryAgainClick()" class="w-full">{{
        'common.tryAgain' | translate
      }}</korviu-button>
    }
    <!-- ALREADY REGISTERED -->
    @if (isStatusAlreadyRegistered) {
      <korviu-button color="ghost" (click)="onCancelClick()" class="w-full">{{
        'common.cancel' | translate
      }}</korviu-button>
    }
    @if (isStatusAlreadyRegistered) {
      <korviu-button color="tertiary" (click)="onAddGanamigosClick()" class="w-full">{{
        'referral.addGanamigo' | translate
      }}</korviu-button>
    }
    <!-- INVITATION ALREADY SENT -->
    @if (isStatusInvitationAlreadySent) {
      <korviu-button color="ghost" (click)="onAddReferralClick()" class="w-full">{{
        'common.back' | translate
      }}</korviu-button>
    }
    @if (isStatusInvitationAlreadySent) {
      <korviu-button color="tertiary" class="w-full" (click)="onTrackReferralClick()">
        {{ 'referral.trackReferral' | translate }}
      </korviu-button>
    }
  </div>
</div>
